import {
  type Card,
  type CardIdentifier,
} from '@/types/productSelectionAndCheckout/types';

export const findCardByIdentifier = (
  cards: Card[],
  identifier: CardIdentifier,
) => {
  if (identifier.fullSizeItemId) {
    return cards.find(
      (card) => card.fullSizeItemId === identifier.fullSizeItemId,
    );
  }

  if (identifier.fullSizeItemIds) {
    return cards.find((card) => {
      return card.fullSizeItemIds?.every((id) =>
        identifier.fullSizeItemIds?.includes(id),
      );
    });
  }

  return undefined;
};
